export interface Article {
  id: string;
  title: string;
  summary: string;
  categoryId: string;
  categoryName: string;
  categorySlug: string;
  author: string;
  authorAvatar: string;
  publishDate: string;
  readCount: number;
  likeCount: number;
  commentCount: number;
  isHot: boolean;
  isRecommend: boolean;
  image: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: '1',
    title: '某顶流男星深夜密会神秘女子，两人共处三小时后先后离开酒店',
    summary: '据知情人爆料，某一线男星在结束剧组拍摄后并未直接回酒店休息，而是驱车前往市中心某高档会所，与一名戴着口罩帽子的神秘女子共进晚餐。两人用餐后一同前往附近五星级酒店，约三小时后先后离开。该男星此前一直以"单身人设"示人，此消息一出粉丝炸锅。',
    categoryId: 'entertainment',
    categoryName: '娱乐八卦',
    categorySlug: 'yule-bagua',
    author: '吃瓜小分队',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20watermelon%20character%20avatar%2C%20flat%20design%20style%2C%20warm%20coral%20and%20green%20colors%2C%20clean%20white%20background%2C%20friendly%20expression&width=200&height=200&seq=avatar-1&orientation=squarish',
    publishDate: '2026-07-02',
    readCount: 128456,
    likeCount: 3421,
    commentCount: 567,
    isHot: true,
    isRecommend: true,
    image: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20lobby%20at%20night%20with%20elegant%20chandelier%20lighting%2C%20mysterious%20atmosphere%2C%20warm%20amber%20and%20gold%20tones%2C%20editorial%20photography%20style%2C%20shallow%20depth%20of%20field%2C%20dramatic%20lighting&width=800&height=500&seq=article-1&orientation=landscape',
    tags: ['明星', '爆料', '深夜'],
  },
  {
    id: '2',
    title: '日本发明"睡眠咖啡馆"，花50元就能在棺材里睡个午觉',
    summary: '东京新宿区最近开了一家名为"永眠咖啡"的奇特咖啡馆，店内装饰成灵堂风格，提供仿真棺材供客人午休。顾客可以选择不同款式的棺材，包括日式传统棺木和西式现代款，还提供"超度"按摩服务。开业一个月，每天都排长队，成为社交媒体热门打卡地。',
    categoryId: 'curious',
    categoryName: '猎奇趣闻',
    categorySlug: 'lieqi-quwen',
    author: '好奇猫',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20cat%20with%20curious%20expression%20avatar%2C%20flat%20design%20style%2C%20warm%20amber%20and%20cream%20colors%2C%20clean%20white%20background&width=200&height=200&seq=avatar-2&orientation=squarish',
    publishDate: '2026-07-01',
    readCount: 89234,
    likeCount: 2156,
    commentCount: 432,
    isHot: true,
    isRecommend: false,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20minimalist%20cafe%20interior%20with%20unusual%20coffin-shaped%20furniture%2C%20soft%20ambient%20lighting%2C%20warm%20wood%20tones%20and%20cream%20walls%2C%20cozy%20yet%20quirky%20atmosphere%2C%20editorial%20interior%20photography&width=800&height=500&seq=article-2&orientation=landscape',
    tags: ['日本', '奇葩', '咖啡馆'],
  },
  {
    id: '3',
    title: '某选秀女团成员退团内幕曝光：凌晨三点被经纪人叫去"单独谈话"',
    summary: '日前退团的选秀女团成员小A在社交媒体上发布长文，揭露了经纪公司的不为人知的内幕。据她透露，练习生期间每天训练超过14小时，公司还以"造型指导"为由安排深夜单独会面。她称最终选择退团是因为"不想再做一个没有灵魂的提线木偶"。文章发布后三小时被删除，但已被网友截图疯狂转发。',
    categoryId: 'celebrity',
    categoryName: '明星爆料',
    categorySlug: 'mingxing-baoliao',
    author: '圈内人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20detective%20magnifying%20glass%20character%20avatar%2C%20flat%20design%20style%2C%20warm%20brown%20and%20cream%20colors%2C%20clean%20white%20background%2C%20curious%20expression&width=200&height=200&seq=avatar-3&orientation=squarish',
    publishDate: '2026-07-01',
    readCount: 156789,
    likeCount: 4892,
    commentCount: 1023,
    isHot: true,
    isRecommend: true,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20stage%20spotlight%20scene%20with%20silhouette%20of%20performer%2C%20dark%20theater%20background%2C%20single%20bright%20beam%20of%20light%2C%20mysterious%20and%20intense%20atmosphere%2C%20warm%20coral%20and%20amber%20tones%2C%20cinematic%20photography&width=800&height=500&seq=article-3&orientation=landscape',
    tags: ['女团', '内幕', '选秀'],
  },
  {
    id: '4',
    title: '大爷公园里遛机械恐龙，路人纷纷拍照：比真狗还听话',
    summary: '北京朝阳公园近日出现一位遛机械恐龙的大爷，引得路人纷纷围观拍照。这只高约1米的机械霸王龙不仅能走路，还能摇尾巴、发出吼叫声，甚至能听懂"坐下""握手"等指令。大爷介绍这是他自己花了三个月用废旧零件组装的，造价不到500元。网友们笑称："大爷这是领先我们一个版本啊！"',
    categoryId: 'social',
    categoryName: '社会奇闻',
    categorySlug: 'shehui-qiwen',
    author: '街头观察员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20camera%20character%20avatar%2C%20flat%20design%20style%2C%20warm%20coral%20and%20gray%20colors%2C%20clean%20white%20background%2C%20friendly%20expression&width=200&height=200&seq=avatar-4&orientation=squarish',
    publishDate: '2026-06-30',
    readCount: 67890,
    likeCount: 1876,
    commentCount: 298,
    isHot: false,
    isRecommend: true,
    image: 'https://readdy.ai/api/search-image?query=Sunny%20park%20scene%20with%20people%20gathering%20around%20a%20small%20mechanical%20dinosaur%20robot%2C%20warm%20afternoon%20lighting%2C%20green%20trees%20and%20grass%2C%20cheerful%20atmosphere%2C%20warm%20tones%2C%20lifestyle%20editorial%20photography&width=800&height=500&seq=article-4&orientation=landscape',
    tags: ['大爷', '机械', '公园'],
  },
  {
    id: '5',
    title: '2026上半年十大网络热梗盘点：你知道几个？',
    summary: '从"精神状态领先"到"我有一个朋友"，从"显眼包"到"命运的齿轮"，2026年上半年的网络热梗层出不穷。本文盘点十大最火网络梗，带你回顾这半年的互联网记忆。每一个梗背后都有一段故事，快来看看你知道几个？',
    categoryId: 'meme',
    categoryName: '网络热梗',
    categorySlug: 'wangluo-regeng',
    author: '梗百科',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20speech%20bubble%20character%20avatar%2C%20flat%20design%20style%2C%20warm%20coral%20and%20yellow%20colors%2C%20clean%20white%20background%2C%20playful%20expression&width=200&height=200&seq=avatar-5&orientation=squarish',
    publishDate: '2026-06-29',
    readCount: 234567,
    likeCount: 6789,
    commentCount: 1456,
    isHot: true,
    isRecommend: true,
    image: 'https://readdy.ai/api/search-image?query=Colorful%20collage%20of%20social%20media%20trending%20meme%20elements%2C%20speech%20bubbles%2C%20emoji%2C%20and%20trend%20arrows%20floating%20in%20warm%20gradient%20background%2C%20coral%20and%20amber%20color%20palette%2C%20modern%20digital%20art%20style%2C%20energetic%20composition&width=800&height=500&seq=article-5&orientation=landscape',
    tags: ['热梗', '盘点', '2026'],
  },
  {
    id: '6',
    title: '心理学家揭秘：为什么人们爱"吃瓜"？原来有科学依据',
    summary: '为什么一条明星八卦能在几小时内引爆全网？心理学家指出，"吃瓜"行为背后有深层的心理机制。进化心理学认为，关注他人的社交信息是人类与生俱来的本能；社会心理学则认为，八卦是建立群体归属感的工具。更有趣的是，研究表明适度"吃瓜"还能缓解压力、提升幸福感。',
    categoryId: 'decompress',
    categoryName: '解压谈资',
    categorySlug: 'jieya-tanzi',
    author: '心理观察',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20brain%20character%20avatar%2C%20flat%20design%20style%2C%20warm%20pink%20and%20cream%20colors%2C%20clean%20white%20background%2C%20thoughtful%20expression&width=200&height=200&seq=avatar-6&orientation=squarish',
    publishDate: '2026-06-28',
    readCount: 45234,
    likeCount: 1234,
    commentCount: 234,
    isHot: false,
    isRecommend: false,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20conceptual%20art%20of%20human%20brain%20with%20social%20connections%20and%20speech%20bubbles%2C%20warm%20coral%20and%20amber%20gradient%20background%2C%20soft%20and%20intellectual%20atmosphere%2C%20modern%20digital%20illustration%20style&width=800&height=500&seq=article-6&orientation=landscape',
    tags: ['心理学', '吃瓜', '科学'],
  },
  {
    id: '7',
    title: '某女星被曝隐婚生子，孩子生父竟是圈内知名导演',
    summary: '一线女星小B被狗仔拍到带孩子出入某私立幼儿园，经多方核实确认孩子已三岁。更令人震惊的是，据知情人士透露，孩子生父竟是圈内一位以"风流"著称的知名导演C某。两人此前在多个项目中有过合作，曾传出绯闻但都被否认。此消息一出，网友纷纷表示"贵圈真乱"。',
    categoryId: 'celebrity',
    categoryName: '明星爆料',
    categorySlug: 'mingxing-baoliao',
    author: '狗仔队长',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20paparazzi%20camera%20with%20flash%20character%20avatar%2C%20flat%20design%20style%2C%20warm%20dark%20gray%20and%20coral%20colors%2C%20clean%20white%20background&width=200&height=200&seq=avatar-7&orientation=squarish',
    publishDate: '2026-06-28',
    readCount: 198765,
    likeCount: 5678,
    commentCount: 1890,
    isHot: true,
    isRecommend: false,
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20night%20scene%20outside%20luxury%20residential%20building%2C%20blurred%20figures%20in%20distance%2C%20street%20lamp%20glow%2C%20paparazzi%20style%20photography%2C%20warm%20amber%20and%20dark%20shadows%2C%20grainy%20cinematic%20look&width=800&height=500&seq=article-7&orientation=landscape',
    tags: ['女星', '隐婚', '导演'],
  },
  {
    id: '8',
    title: '印度男子为破世界纪录，连续37天不睡觉："我感觉自己快成仙了"',
    summary: '印度拉贾斯坦邦一名男子为了打破人类不睡觉的世界纪录，连续37天保持清醒状态。期间他通过高强度运动、冷水浴和冥想维持清醒。医生多次警告他可能出现永久性脑损伤，但他坚持表示"快要突破人类极限了"。最终在第38天被强制送医，检查时发现自己已有轻度精神分裂症状。',
    categoryId: 'curious',
    categoryName: '猎奇趣闻',
    categorySlug: 'lieqi-quwen',
    author: '世界奇闻录',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20globe%20character%20avatar%2C%20flat%20design%20style%2C%20warm%20green%20and%20cream%20colors%2C%20clean%20white%20background%2C%20surprised%20expression&width=200&height=200&seq=avatar-8&orientation=squarish',
    publishDate: '2026-06-27',
    readCount: 56789,
    likeCount: 987,
    commentCount: 156,
    isHot: false,
    isRecommend: true,
    image: 'https://readdy.ai/api/search-image?query=Surreal%20scene%20of%20man%20meditating%20with%20clock%20elements%20and%20time%20distortion%20visuals%2C%20warm%20sunset%20colors%2C%20dreamy%20and%20mystical%20atmosphere%2C%20coral%20and%20amber%20tones%2C%20editorial%20conceptual%20photography&width=800&height=500&seq=article-8&orientation=landscape',
    tags: ['世界纪录', '印度', '奇人'],
  },
  {
    id: '9',
    title: '某剧组被曝拖欠群演工资，群演集体睡片场抗议',
    summary: '某古装大剧组被曝拖欠群演工资长达两个月，数百名群演在片场搭帐篷过夜抗议。据现场拍摄的视频显示，群演们举着"还我血汗钱"的横幅，场面一度十分混乱。剧组方面回应称是"资金周转问题"，承诺一周内解决。网友热议：明星住五星级酒店，群演睡帐篷，差距太大了。',
    categoryId: 'entertainment',
    categoryName: '娱乐八卦',
    categorySlug: 'yule-bagua',
    author: '片场小记者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20microphone%20reporter%20character%20avatar%2C%20flat%20design%20style%2C%20warm%20coral%20and%20brown%20colors%2C%20clean%20white%20background&width=200&height=200&seq=avatar-9&orientation=squarish',
    publishDate: '2026-06-27',
    readCount: 87654,
    likeCount: 2345,
    commentCount: 567,
    isHot: false,
    isRecommend: false,
    image: 'https://readdy.ai/api/search-image?query=Film%20set%20behind%20the%20scenes%20at%20night%20with%20temporary%20tents%20and%20protest%20banners%2C%20dramatic%20artificial%20lighting%2C%20warm%20amber%20and%20dark%20shadows%2C%20documentary%20style%20photography%2C%20cinematic%20atmosphere&width=800&height=500&seq=article-9&orientation=landscape',
    tags: ['剧组', '拖欠工资', '群演'],
  },
  {
    id: '10',
    title: '"我有一个朋友"系列爆红：当代网友的新型叙事方式',
    summary: '"我有一个朋友，他..."这个句式近期在各大社交平台爆红。网友们用它来包装各种难以启齿的故事——从尴尬经历到情感糗事，甚至职场八卦。语言学专家分析，这种叙事方式既满足了倾诉欲，又保留了最后的体面，堪称当代互联网社交的语言智慧。',
    categoryId: 'meme',
    categoryName: '网络热梗',
    categorySlug: 'wangluo-regeng',
    author: '语言观察家',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20book%20and%20pen%20character%20avatar%2C%20flat%20design%20style%2C%20warm%20amber%20and%20cream%20colors%2C%20clean%20white%20background%2C%20scholarly%20expression&width=200&height=200&seq=avatar-10&orientation=squarish',
    publishDate: '2026-06-26',
    readCount: 345678,
    likeCount: 8901,
    commentCount: 2345,
    isHot: true,
    isRecommend: true,
    image: 'https://readdy.ai/api/search-image?query=Creative%20typography%20art%20with%20Chinese%20characters%20&width=800&height=500&seq=article-10&orientation=landscape"friend"%20and%20speech%20bubbles%20floating%20in%20warm%20gradient%20space%2C%20coral%20and%20amber%20color%20palette%2C%20modern%20digital%20illustration%20style%2C%20playful%20composition',
    tags: ['热梗', '语言', '社交'],
  },
  {
    id: '11',
    title: ' scientists发现人类"第六感"：能感知他人正在看自己',
    summary: '剑桥大学一项最新研究发现，人类确实拥有一种类似"被注视感知"的能力。实验显示，当有人从背后注视受试者时，受试者的皮肤电反应会出现微妙变化，准确率超过随机概率。研究者推测这可能与进化中的捕食者侦测机制有关。网友调侃："终于知道为什么背后发凉不是迷信了。"',
    categoryId: 'social',
    categoryName: '社会奇闻',
    categorySlug: 'shehui-qiwen',
    author: '科学菌',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20test%20tube%20and%20flask%20character%20avatar%2C%20flat%20design%20style%2C%20warm%20green%20and%20cream%20colors%2C%20clean%20white%20background&width=200&height=200&seq=avatar-11&orientation=squarish',
    publishDate: '2026-06-25',
    readCount: 234567,
    likeCount: 6789,
    commentCount: 1234,
    isHot: true,
    isRecommend: false,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20scientific%20visualization%20of%20human%20eye%20and%20neural%20network%20connections%2C%20glowing%20warm%20amber%20and%20coral%20lights%20on%20dark%20background%2C%20futuristic%20yet%20organic%20feel%2C%20editorial%20digital%20art&width=800&height=500&seq=article-11&orientation=landscape',
    tags: ['科学', '第六感', '发现'],
  },
  {
    id: '12',
    title: '治愈系：陌生人之间的温暖瞬间合集，看完心都化了',
    summary: '本期整理全网最令人心暖的陌生人互助瞬间：地铁上默默为睡着的农民工垫头的女生、暴雨中为流浪猫撑伞的外卖小哥、深夜便利店给失意年轻人多盛一勺关东煮的店员......这些微小但温暖的瞬间，证明这个世界依然值得被爱。网友纷纷表示"看得眼眶湿润"。',
    categoryId: 'decompress',
    categoryName: '解压谈资',
    categorySlug: 'jieya-tanzi',
    author: '温暖收集者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20heart%20with%20wings%20character%20avatar%2C%20flat%20design%20style%2C%20warm%20coral%20and%20pink%20colors%2C%20clean%20white%20background%2C%20gentle%20expression&width=200&height=200&seq=avatar-12&orientation=squarish',
    publishDate: '2026-06-24',
    readCount: 456789,
    likeCount: 23456,
    commentCount: 3456,
    isHot: true,
    isRecommend: true,
    image: 'https://readdy.ai/api/search-image?query=Warm%20heartwarming%20street%20scene%20with%20people%20helping%20each%20other%2C%20soft%20golden%20hour%20lighting%2C%20warm%20amber%20and%20coral%20tones%2C%20tender%20and%20emotional%20atmosphere%2C%20editorial%20lifestyle%20photography&width=800&height=500&seq=article-12&orientation=landscape',
    tags: ['治愈', '温暖', '正能量'],
  },
];

export const getArticleById = (id: string) => articles.find((a) => a.id === id);
export const getArticlesByCategory = (categoryId: string) => articles.filter((a) => a.categoryId === categoryId);
export const getHotArticles = () => articles.filter((a) => a.isHot).slice(0, 6);
export const getRecommendArticles = () => articles.filter((a) => a.isRecommend).slice(0, 8);
export const getLatestArticles = (count = 8) => articles.slice(0, count);
export const getRelatedArticles = (currentId: string, categoryId: string, count = 4) => {
  return articles
    .filter((a) => a.id !== currentId && a.categoryId === categoryId)
    .slice(0, count);
};